import React from "react";

import PropTypes from "prop-types";

import {
  errorPanelContainer,
  textWrapperStyle,
  ctaWrapperStyle,
  ctaStyle,
  messageHeaderStyle,
  messageBodyStyle,
} from "./ErrorPanel.style";

const defaultErrorMessage = {
  messageHeader: "Something went wrong",
  messageBody:
    "Please go back and try again. Contact Customer Support if the problem continues.",
  cta: "https://support.newsela.com/contact/",
  ctaText: "Contact Customer Support",
};

export default function ErrorPanel({
  messageHeader,
  messageBody,
  cta,
  ctaText,
  ctaSecondary,
  ctaSecondaryText,
}) {
  const ctaButtonorLink = (link, text) => {
    return (
      <a aria-label={text} href={link} css={ctaStyle}>
        {text}
      </a>
    );
  };

  const renderCTA = (link, text) => {
    return (
      <a aria-label={text} href={link} css={ctaStyle}>
        {text}
      </a>
    );
  };
  return (
    <div css={errorPanelContainer}>
      <div css={textWrapperStyle}>
        <h1 css={messageHeaderStyle}>{messageHeader}</h1>
        <div css={messageBodyStyle}>{messageBody}</div>
      </div>
      <div css={ctaWrapperStyle}>
        {renderCTA(cta, ctaText)}
        {ctaSecondaryText && ctaButtonorLink(ctaSecondary, ctaSecondaryText)}
      </div>
    </div>
  );
}

ErrorPanel.propTypes = {
  messageHeader: PropTypes.string,
  messageBody: PropTypes.string,
  /**
   * Call-to-action(CTA) path
   */
  cta: PropTypes.string,
  /**
   * Call-to-action(CTA) text
   */
  ctaText: PropTypes.string,
  /**
   * Second call-to-action(CTA) path
   */
  ctaSecondary: PropTypes.string,
  /**
   * Second call-to-action(CTA) text
   */
  ctaSecondaryText: PropTypes.string,
};

ErrorPanel.defaultProps = {
  messageHeader: defaultErrorMessage.messageHeader,
  messageBody: defaultErrorMessage.messageBody,
  cta: defaultErrorMessage.cta,
  ctaText: defaultErrorMessage.ctaText,
};
